import { GraphQLResult, GRAPHQL_AUTH_MODE } from '@aws-amplify/api';
import * as R from 'ramda';
import {
  Experience,
  ListMainSkillsWithOpenPositionsQuery,
  ListTechnicalSkillsQuery,
  SkillArea,
  SkillFrequency,
  SkillType,
} from '../API';
import callGraphQL from '../graphql-wrapper';
import { listMainSkillsWithOpenPositions, listTechnicalSkills } from '../graphql/queries';

interface TechnicalSkill {
  id: string;
  name: string;
  type?: SkillType | null;
  area: SkillArea;
  frequency?: SkillFrequency | null;
}

export const SKILL_AREA_HUMAN_NAMES = {
  [SkillArea.FRONTEND]: 'Front-end',
  [SkillArea.BACKEND]: 'Back-end',
  [SkillArea.MOBILE]: 'Mobile',
} as Record<SkillArea, string>;

function mapTechnicalSkills(skills: TechnicalSkill[]) {
  return R.map(
    R.compose(
      R.pick(['id', 'name', 'type', 'area', 'frequency']),
      (a: TechnicalSkill) => a!,
    ),
    skills,
  );
}

function mapSkillsQuery(
  listTechnicalSkillsQuery: GraphQLResult<ListTechnicalSkillsQuery>,
): TechnicalSkill[] {
  const list = listTechnicalSkillsQuery.data?.listTechnicalSkills?.items || [];
  return mapTechnicalSkills(
    R.reject(R.isNil, list) as NonNullable<typeof list[0]>[],
  );
}

function listTechnicalSkillsWrapper() {
  return callGraphQL<ListTechnicalSkillsQuery>(
    listTechnicalSkills,
    { authMode: GRAPHQL_AUTH_MODE.API_KEY },
  ).then(mapSkillsQuery);
}

function mapMainSkillsWithOpenJobsQuery(
  listMainSkillsWithOpenPositionsQuery: GraphQLResult<ListMainSkillsWithOpenPositionsQuery>,
): TechnicalSkill[] {
  return mapTechnicalSkills(
    listMainSkillsWithOpenPositionsQuery.data?.listMainSkillsWithOpenPositions || [],
  );
}

function listMainSkillsWithOpenPositionsWrapper(maxExperience?: Experience) {
  return callGraphQL<ListMainSkillsWithOpenPositionsQuery>(
    listMainSkillsWithOpenPositions,
    {
      variables: { maxExperience },
      authMode: GRAPHQL_AUTH_MODE.API_KEY,
    },
  ).then(mapMainSkillsWithOpenJobsQuery);
}

export default TechnicalSkill;
export {
  listTechnicalSkillsWrapper as listTechnicalSkills,
  listMainSkillsWithOpenPositionsWrapper as listMainSkillsWithOpenPositions,
};
